/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChoiceAnswerModel } from './ChoiceAnswerModel';
export type ChildIndividual = {
  readonly id?: number;
  name: string;
  question_type: ChildIndividual.question_type;
  options: Array<ChoiceAnswerModel>;
  description?: string | null;
  readonly answered?: string;
};
export namespace ChildIndividual {
  export enum question_type {
    TEXT = 'text',
    DATE = 'date',
    DROPDOWN = 'dropdown',
    MULTIPLE = 'multiple',
  }
}
